<!-- filterBar.vue (template) -->
<template>
    <div id="filters" class="w-full flex items-center gap-3">
      <div class="relative flex-1">
        <i class="absolute left-3 top-1/2 -translate-y-1/2 inline-block h-5 w-5 mask mask-search bg-gray-400"></i>
        <input
          type="text"
          class="w-full h-11 pl-10 pr-10 rounded-xl bg-[#E6EEF8] text-gray-700 placeholder-gray-400 outline-none
                 focus:ring-2 focus:ring-secondary focus:bg-white/90 transition"
          :placeholder="placeholderFilter"
          v-model="searchingBar"
          @input="emitString"
        />
        <button
          type="button"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-lg leading-none"
          aria-label="Réinitialiser la recherche"
          @click="resetSearch"
        >
          &times;
        </button>
      </div>
    </div>
  </template>

  <script>
  import History from '../../js/core/History'

  export default {
    props: {
      placeholderFilter: String,
      typeHistory: String
    },
    data() {
      return {
        searchingBar: ''
      }
    },
    methods: {
      async emitString() {
        await this.$emit('searchBarChanged', [this.searchingBar])
        if (typeof this.typeHistory !== 'undefined') {
          await History.setHistory(this.typeHistory, { text: this.searchingBar })
        }
      },
      resetSearch() {
        if (typeof this.typeHistory !== 'undefined') {
          History.clearHistory(this.typeHistory, 'text')
        }
        this.searchingBar = ''
        this.$emit('searchBarChanged', [this.searchingBar])
      }
    },
    async mounted() {
      if (typeof this.typeHistory === 'undefined') return
      const history = await History.getHistory(this.typeHistory)
      if (!history) return
      if (typeof history.text !== 'undefined') {
        this.searchingBar = history.text
        this.$emit('searchBarChanged', [this.searchingBar])
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// FilterBar.vue?d610cb98